import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PdfNotificationStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<circle cx="18.75" cy="5" r="4" fill="#1E72BD" stroke="white" strokeWidth="2" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.2035 9.9651C14.2168 9.9683 14.2301 9.97128 14.2435 9.97405L14.2035 9.9651ZM14.2035 9.9651C14.2168 9.9683 14.2301 9.97128 14.2435 9.97405L14.2035 9.9651Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.2435 9.97405C14.2301 9.97128 14.2168 9.9683 14.2035 9.9651C14.1373 9.94911 14.0731 9.92784 14.0115 9.90177C13.6617 9.75382 13.3933 9.4512 13.292 9.07967C13.2854 9.05524 13.2786 9.02692 13.2734 9.00192C13.2568 8.92055 13.248 8.83629 13.248 8.75L13.25 3.43945L13.0303 3.21973C12.8896 3.07907 12.6989 3 12.5 3H5.5C3.98122 3 2.75 4.23122 2.75 5.75V21.75C2.75 23.2688 3.98122 24.5 5.5 24.5H19.5C19.9142 24.5 20.25 24.1642 20.25 23.75C20.25 23.479 20.1063 23.2416 19.8909 23.1098C19.777 23.0401 19.6432 23 19.5 23H5.5C4.80964 23 4.25 22.4404 4.25 21.75V5.75C4.25 5.05964 4.80964 4.5 5.5 4.5H11.748V8.75C11.748 10.2688 12.9794 11.5 14.498 11.5H18.75V12.75C18.75 13.1642 19.0858 13.5 19.5 13.5C19.9142 13.5 20.25 13.1642 20.25 12.75V10.75C20.25 10.5511 20.1709 10.3604 20.0303 10.2197L19.8105 10H14.498C14.4118 10 14.3248 9.9907 14.2435 9.97405Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.9875 16.7625C11.3395 16.7625 11.625 17.0479 11.625 17.4C11.625 17.7521 11.3395 18.0375 10.9875 18.0375H10.35V16.7625H10.9875ZM9.07495 16.125C9.07495 15.9617 9.13633 15.8128 9.23728 15.7C9.35401 15.5696 9.52365 15.4875 9.71245 15.4875H10.9875C11.4429 15.4875 11.8612 15.6467 12.1896 15.9125C12.6229 16.2631 12.9 16.7992 12.9 17.4C12.9 17.6235 12.8616 17.8381 12.7911 18.0375C12.5286 18.7803 11.8202 19.3125 10.9875 19.3125H10.35V20.375C10.35 20.7271 10.0645 21.0125 9.71245 21.0125C9.36037 21.0125 9.07495 20.7271 9.07495 20.375V16.125Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.3875 15.4875C14.0354 15.4875 13.75 15.7729 13.75 16.125V20.375C13.75 20.7271 14.0354 21.0125 14.3875 21.0125H15.4803C16.6201 21.0125 17.575 20.1096 17.575 18.9583V17.5417C17.575 16.3904 16.6201 15.4875 15.4803 15.4875H14.3875ZM16.2098 19.3125C16.0767 19.56 15.8075 19.7375 15.4803 19.7375H15.025V16.7625H15.4803C15.95 16.7625 16.3 17.1282 16.3 17.5417V18.9583C16.3 19.0837 16.2678 19.2047 16.2098 19.3125Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.0625 21.0125C19.137 21.0125 19.2085 20.9997 19.275 20.9762C19.5226 20.8887 19.7 20.6526 19.7 20.375V18.8875H21.1875C21.5395 18.8875 21.825 18.6021 21.825 18.25C21.825 17.8979 21.5395 17.6125 21.1875 17.6125H19.7V16.7625H21.6125C21.9645 16.7625 22.25 16.4771 22.25 16.125C22.25 15.7729 21.9645 15.4875 21.6125 15.4875H19.0625C18.7104 15.4875 18.425 15.7729 18.425 16.125V20.375C18.425 20.7271 18.7104 21.0125 19.0625 21.0125Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PdfNotificationStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PdfNotificationStrokeIcon;
